import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ActionPlanComponent } from './action-plans/action-plans.component';
import { EnterpriseComponent } from './enterprise/enterprise.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotPasswordTokenComponent } from './forgot-password-token/forgot-password-token.component';
import { NewPasswordTokenComponent } from './new-password-token/new-password-token.component';

export const authRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'action-plans',
    component: ActionPlanComponent
  },
  {
    path: 'enterprise',
    component: EnterpriseComponent
  },
  {
    path: 'forgot-password/:token',
    component: ForgotPasswordTokenComponent
  },
  {
    path: 'new-password/:token',
    component: NewPasswordTokenComponent
  }
];



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/auth/auth.routing.ts